import { useQuery } from '@tanstack/react-query';
import { getPackageHistory } from '@/services/supabasePackages';

export function usePackageHistory(packageId: number | string | undefined) {
  return useQuery({
    queryKey: ['package_history', packageId],
    enabled: !!packageId,
    queryFn: async () => {
      if (!packageId) return [];
      const idNum = typeof packageId === 'string' ? parseInt(packageId, 10) : packageId;
      if (!idNum || isNaN(idNum)) return [];
      return await getPackageHistory(idNum);
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false,
    retry: 2,
  });
} 